export const VIRALIZE_QUALIFICATION_INTRO_VIDEO_SRC =
  '/videos/viralize-qualification-intro-v2.mp4';
